import Vue from 'vue'
import Router from 'vue-router'
const ManageFile = () => import('@/components/manage_file')
const DetailFile = () => import('@/components/detail_file')
const BillDetail = () => import('@/components/bill_detail')
const ImagePreview = () => import('@/components/image_preview')
const Login = () => import('@/components/Login')
const Report = () => import('@/components/report_file')
const Email = () => import('@/components/search_email')
const Storage = () => import('@/components/storage')
const Profile = () => import('@/components/profile')
const Addmail = () => import('@/components/addmail')
const NewBill = () => import('@/components/new_bill')
const NewReport = () => import('@/components/new_report')
const Page404 = () => import('@/components/404')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: ManageFile
    },
    {
      path: '/bill/:key',
      name: 'Detail',
      component: DetailFile
    },
    {
      path: '/detail/:key',
      name: 'BillDetail',
      component: BillDetail
    },
    {
      path: '/addmail/:key',
      name: 'Addmail',
      component: Addmail
    },
    {
      path: '/images/:key/:id',
      name: 'ImagePreview',
      component: ImagePreview
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/addFolder',
      name: 'addFolder',
      component: NewBill
    },
    {
      path: '/email',
      name: 'Email',
      component: Email
    },
    {
      path: '/storage',
      name: 'storage',
      component: Storage
    },
    {
      path: '/newreport',
      name: 'newreport',
      component: NewReport
    },
    {
      path: '*',
      component: Page404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js